export default "__VITE_ASSET__CBfzvr2o__"